module.exports = __webpack_public_path__ + "static/img/chanta (8).878d124.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chanta/chanta (8).jpg
// module id = sBhU
// module chunks = 0